export const handleKeyDown = (event: any, callback: Function) => {
  if (event) {
    if (event.key === ' ' || event.key === 'Enter' || event.key === 'Spacebar') {
      event.preventDefault();
      if (callback) {
        callback();
      }
    }
  }
};
